import { render, staticRenderFns } from "./addroute.vue?vue&type=template&id=3b8a3009&"
import script from "./addroute.vue?vue&type=script&lang=js&"
export * from "./addroute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8a3009')) {
      api.createRecord('3b8a3009', component.options)
    } else {
      api.reload('3b8a3009', component.options)
    }
    module.hot.accept("./addroute.vue?vue&type=template&id=3b8a3009&", function () {
      api.rerender('3b8a3009', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/gatewayroutes/addroute.vue"
export default component.exports